import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import { uiStateReducer } from 'react-redux-ui-state';
import notifications from './notifications';
import apitokens from './apitokens';
import instances from './instances';
import instancesV4 from './instancesORv4';
import user from './user';
import usersManagement from './usersManagement';
import usersInviteSignup from './usersInviteSignup';
import org from './org';
import createInstance, { createInstanceForms } from './createInstance';
import catalog from './catalog';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    notifications,
    form: formReducer.plugin(createInstanceForms),
    uiState: uiStateReducer,
    user,
    usersManagement,
    usersInviteSignup,
    org,
    apitokens,
    instances,
    createInstance,
    catalog,
    instancesV4,
  });
